/**
 * Created by neo on 22.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { Audited, createAuditedFields } from '../../Audited';

export type MindfulnessProgramPhase = Audited & {
  athleteId: string;
  programId: string;
  phaseTemplateId: string;
  startDateTime: Date;
  endDateTime?: Date;
  currentWeekId: string;
  weekIds: string[];
  isLastPhase: boolean;
};

export function createMindfulnessProgramPhase(json?: Partial<MindfulnessProgramPhase>): MindfulnessProgramPhase {
  const audited = createAuditedFields(json);
  return makeAutoObservable({
    ...audited,
    athleteId: json?.athleteId ?? '',
    programId: json?.programId ?? '',
    phaseTemplateId: json?.phaseTemplateId ?? '',
    startDateTime: json?.startDateTime ? new Date(json.startDateTime as any) : new Date(),
    endDateTime: json?.endDateTime ? new Date(json.endDateTime as any) : undefined,
    currentWeekId: json?.currentWeekId ?? '',
    weekIds: json?.weekIds ?? [],
    isLastPhase: json?.isLastPhase ?? false,
  });
}
